/*
 * @Description 组件 今日报警
 * @Author 
 * @Date 
 */
/* HTML */
<template>
	<!-- index-sub-item start -->
	<div class="index-sub-item sub-item-alarmToday">
		<div class="sub-items-box-top"></div>
		
		<!-- sub-alarmToday-box -->
		<div class="sub-items-box-center sub-alarmToday-box">
			<div class="index-sub-title">今日报警统计</div>
			<!-- sub-alarmToday-content start -->
			<div class="abs-center sub-alarmToday-content">
				<i class="alarmToday-content-icon"></i>
				<!-- sub-alarmToday-item start -->
				<div v-for="(item, index) in dataList" :key="index" :class="{'sub-alarmToday-item': true, 'cursor-pointer': item.num > 0}" @click="handleItemBtn(item)" :title="spliceTitle(item)">
					<span class="alarmToday-item-title">{{item.orgtext}}</span>
					<div class="alarmToday-item-content">
						<span class="alarmToday-item-num">{{item.num}}</span>次
					</div>
				</div>
				<!-- sub-alarmToday-item end -->
				
			</div>
			<!-- sub-alarmToday-content end -->
		</div>
		<!-- sub-alarmToday-box -->
		
		<div class="sub-items-box-bottom"></div>
	</div>
	<!-- index-sub-item end -->
</template>

/* JS */
<script>
	// API 类型
	import ApiType from '@/request/api-type';
	// API oam
	import ApiOam from '@/request/api-oam';
	
	export default {
		/**
		 * @Des 组件名
		 * @Auth
		 * @Date 
		 */
        name: "IndAlarmsToday",
        
        /**
		 * @Des 组件注册
		 * @Auth
		 * @Date 
		 */
        components: {
        	
        },// components
        
        /**
		 * @Des 属性值
		 * @Auth
		 * @Date 
		 */
        props: {
        	
        },// props
        
        /**
		 * @Des 数据定义
		 * @Auth
		 * @Date 
		 */
		data() {
			return {
				// 报警数量
				dataList: [
					{num: 0, orgtext: '报警总数', dealState: [1, 2], type: 'real'},
					{num: 0, orgtext: '已处理', dealState: [2], type: 'history'},
				],
				// dealState 0 未处理  1 处理中  2 已处理
				// 报警类型 keys
				alarms: [],
			}
		},// data
		
		/**
		 * @Des 初始化
		 * @Auth
		 * @Date 
		 */
		created() {
			
		},// created
		
		/**
		 * @Des 加载完成
		 * @Auth
		 * @Date 
		 */
		mounted() {
			// 开启订阅消息
			this.startSubscribes();
			
			// 数据查询
			this.searchData();
		},// mounted
		
		/**
		 * @Des 销毁之前
		 * @Auth
		 * @Date 
		 */
		beforeDestroy() {
			// 取消订阅消息
			this.endSubscribes();
		},// beforeDestroy
		
		/**
		 * @Des 销毁
		 * @Auth
		 * @Date 
		 */
		destroyed() {
			
		},// destroyed
		
		/**
		 * @Des 方法定义
		 * @Auth
		 * @Date 
		 */
		methods: {
			//========================== 订阅消息 start ==========================
			/**
			 * @Des 开启订阅消息
			 * @Auth
			 * @Date
			 */
			startSubscribes() {
				// 订阅消息 详情页
				this.sub_dataChange = this.$pubsub.subscribe('AlarmChange', (name, data) => {
					// 数据查询
					this.searchData();
				});
			},
			/**
			 * @Des 取消订阅消息
			 * @Auth
			 * @Date
			 */
			endSubscribes() {
				//取消订阅 详情页
				this.$pubsub.unsubscribe(this.sub_dataChange);
			},
			
			//========================== 订阅消息 end ==========================
			
			/**
			 * @Des 点击条目btn
			 * @Auth
			 * @Date
			 */
			handleItemBtn(row) {
				// 空值 中止
				if (this.$checkEmpty(row)) return false;
				// 无数据 中止
				if (!(row.num > 0)) return false;
				
				// 路由 跳转
				this.$router.replace({path: ('/manager/alarm/' + row.type)}, ()=>{}, ()=>{});
				
				return false;
				// 参数
				let filter = {};
				if (!this.$checkEmpty(row) && !this.$checkEmpty(row.type)) {
					filter.activeName = row.type;
				}
				
				// 点击条目
				this.handleDetailBtn('Alarm', '今日报警', filter);
			},
			
			/**
			 * @Des 点击条目
			 * @Auth
			 * @Date
			 */
			handleDetailBtn(detailSubRef, detailSubName, detailFilters) {
				// 发布消息 详情页
				this.$pubsub.publish('handleDetail', {showDetailFlag: true, detailSubRef: detailSubRef, detailSubName: detailSubName, detailFilters: detailFilters});
			},
			
			/**
			 * @Des title 拼接
			 * @Auth
			 * @Date
			 */
			spliceTitle(row) {
				let title = row.orgtext + '：' +row.num;
				if (row.num > 0) {
					title += '\n（点击查看详情）';
				}
				return title;
			},
			
			//========================== 数据查询 start ==========================
			/**
			 * @Des 查询 数据查询
			 * @Auth 
			 * @Date 
			 */
			searchData(){
				// 数据查询 报警类型
				this.searchAlarmStatus();
			},// searchData
			
			/**
			 * @Des 数据查询 报警类型
			 * @Auth 
			 * @Date 
			 */
			searchAlarmStatus() {
				this.$request.postJsonRequest(ApiType.findTypeApi, {
					projectId: this.$store.state.currentProjectId,
					type: "alarmTypes"
				}).then(result => {
					if(result.code == 0 && result.data.alarmTypes){
						
						// 报警类型 keys
						let alarms = [];
						
						let alarmStatus = Object.assign([], result.data.alarmTypes);
						alarmStatus.forEach((row, index) => {
							// 报警类型 keys
							alarms.push(row.state);
						});
						// 报警类型 keys
						this.alarms = Object.assign([], alarms);
						
						Object.assign([], this.dataList).forEach((row, index) => {
							// 数据查询 报警list
							this.searchAlarm(index);
						});
					}
				}).catch(error => {
					console.error('查询报警类型异常', ApiType.findTypeApi, error);
				})
			},// searchAlarmStatus
			/**
			 * @Des 查询 报警
			 * @Auth 
			 * @Date 
			 */
			searchAlarm(index) {
				let row = Object.assign({}, this.dataList[index]);
				
				let today = this.$moment(new Date()).format('YYYY-MM-DD');
				let startDate = [today, '00:00:00'].join(' ');
				let endDate = [today, '23:59:59'].join(' ');
				
				// 交互 参数
				let formData = {
					projectId: this.$store.state.currentProjectId,
					alarms: Object.assign([], this.alarms),
                    beginTime: new Date(startDate).getTime(),
                    endTime: new Date(endDate).getTime(),
                    dealState: Object.assign([], row.dealState),
                    orderBy: {
                        alarm_date: 'desc'
                    },
                    total: 0,
                    startNum: 0,
                    limit: 1
				};
				
				this.$request.postJsonRequest(ApiOam.Search_Alarm_Uri, formData).then(result => {
					// 报警数量
					this.dataList[index].num = result.total > 0 ? result.total : 0;
				}).catch(error => {
					// 报警数量
					this.dataList[index].num = 0;
					console.error('查询报警数据异常', ApiOam.Search_Alarm_Uri, error);
				})
			},// searchAlarmToday
			//========================== 数据查询 end ==========================
			
		},// methods
		
		/**
		 * @Des 监听
		 * @Auth
		 * @Date 
		 */
		watch: {
			
		},// watch
		
		/**
		 * @Des 实时计算
		 * @Auth
		 * @Date 
		 */
		computed: {
			
		},// computed
		
    }// export default
</script>

/* CSS */
<style lang="scss" scoped>
	
</style>



// WEBPACK FOOTER //
// src/components_index/IndexItems/IndAlarmsToday.vue